/* eslint-disable no-unused-vars */
// proofreader editor-copy
import React, { useCallback, useEffect, useRef, useState } from 'react';
import TopSection from './topSection';
import { Avatar, Box, Paper, Stack } from '@mui/material';
import SidePanel from './sidePanel';
import DetailsSection from './detailsSection';
import { useDispatch, useSelector } from 'react-redux';
import { getUserInfo } from '../../../../utils/UserInfoUtils';
import { useParams } from 'react-router-dom';
import {
  editorRequest,
  getAllSpeakersRequest,
  vendorProofreaderCommentRequest,
  vendorResolveProofreaderRequest,
  saveSlateDataRequest, // Assuming this action exists - add it if not
} from '../../Editor/actions';
import SlateEditor from './slateEditor';
import { getSlateDataRequest } from '../actions/slateDataActions';
import Loading from './loading';
import { Dropdown } from 'react-bootstrap';
import moment from 'moment';
import chat_icon from '../../../../assets/images/chat-dots-icon.svg';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { IMAGE_URL } from '../../../../constants/Config';
import { trackEvent } from '../../../../utils/ga';

const EditorCopy = ({ usePreviousPath, todayWorkClick, setTodayWorkClick, claimFile, setFilterApiCall }) => {
  const dispatch = useDispatch();
  const userInfo = getUserInfo();
  const slateEditorRef = useRef();
  const { id } = useParams();
  const [editor, setEditor] = useState(null);
  const [isEditorReady, setIsEditorReady] = useState(false);
  const { data: transcriptData, loading: slateDataLoading, isClaim } = useSelector((state) => state.slateData);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  let fileLikeData = useSelector((state) => state?.fileLike?.user?.data);
  const [canUndo, setCanUndo] = useState(false);
  const [canRedo, setCanRedo] = useState(false);
  const [dropdownOpenComment, setDropdownOpenComment] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [hasChanges, setHasChanges] = useState(false);
  console.log({ claimFile });
  let vendorProofreaderComment = useSelector((state) => state?.vendorProofreaderComment?.user?.data?.value);
  let vendorProofreaderCommentData = vendorProofreaderComment && JSON.parse(vendorProofreaderComment);
  const vendorResolveProofreaderAPIData = useSelector((state) => state?.vendorResolveProofreader?.user?.data?.success);
  let editorDetails = useSelector((state) => state?.editorDetails?.user?.data);

  const parsedEditorDetails = editorDetails ? JSON.parse(editorDetails?.value || '') : null;
  const isFirstTimeClaimed = useSelector((state) => state?.slateData?.isClaim);

  // Enhanced editor initialization function
  const handleEditorInitialized = (editorInstance) => {
    setEditor(editorInstance);
    setIsEditorReady(true);
  };

  const handleUndo = useCallback(() => {
    if (slateEditorRef.current?.handleUndo) {
      slateEditorRef.current.handleUndo();
    }
  }, []);

  const handleRedo = useCallback(() => {
    if (slateEditorRef.current?.handleRedo) {
      slateEditorRef.current.handleRedo();
    }
  }, []);

  // Track content changes
  const handleContentChange = useCallback(() => {
    setHasChanges(true);
  }, []);

  // // Save data only when triggered by Ctrl+S
  // const handleSave = useCallback(() => {
  //   if (hasChanges && editor && slateEditorRef.current) {
  //     // Get current editor content
  //     const content = JSON.stringify(editor.children);

  //     // Dispatch save action
  //     dispatch(saveSlateDataRequest({
  //       audioFileId: id,
  //       userId: userInfo?.UserId,
  //       content: content
  //     }));

  //     // Reset changes flag after saving
  //     setHasChanges(false);
  //     console.log('Content saved via Ctrl+S');
  //   }
  // }, [hasChanges, editor, id, userInfo, dispatch]);

  // Set up keyboard shortcut for saving
  // useEffect(() => {
  //   const handleKeyDown = (e) => {
  //     if ((e.ctrlKey || e.metaKey) && e.key === 's') {
  //       e.preventDefault(); // Prevent browser's default save dialog
  //       handleSave();
  //     }
  //   };

  //   window.addEventListener('keydown', handleKeyDown);
  //   return () => {
  //     window.removeEventListener('keydown', handleKeyDown);
  //   };
  // }, [handleSave]);

  const formatDateWithMilliseconds = () => {
    const date = new Date();

    // Extract components
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const milliseconds = String(date.getMilliseconds()).padStart(3, '0'); // 3 digits for milliseconds

    // Format as YYYY-mm-dd hh:mm:ss.mmm
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
  };

  useEffect(() => {
    let params = {
      audioFileId: id,
      userId: userInfo?.UserId,
      isClickOnClaim: claimFile || isClaim,
      isRestore: false,
      claimDate: formatDateWithMilliseconds(),
    };
    dispatch(editorRequest(params));
    dispatch(
      vendorProofreaderCommentRequest({
        audioFileId: id,
        userId: userInfo?.UserId,
      }),
    );
    dispatch(getAllSpeakersRequest(id));
  }, []);
  useEffect(() => {
    if (parsedEditorDetails?.Status) {
      console.log('claim', claimFile || isFirstTimeClaimed);
      dispatch(
        getSlateDataRequest({
          id,
          status: parsedEditorDetails?.Status?.toLowerCase(),
          isClickOnClaim: claimFile || isFirstTimeClaimed,
        }),
      );
    }
  }, [parsedEditorDetails?.Status]);

  const handleCloseDropdownComment = () => {
    setDropdownOpenComment(false);
  };

  const handleResolved = (dataId) => {
    if (dataId) {
      dispatch(
        vendorResolveProofreaderRequest({
          id: dataId,
          userId: userInfo?.UserId,
        }),
      );
    }
  };

  const handleToggleDropdownComment = (isOpen) => {
    setDropdownOpenComment(isOpen);
  };

  const formatDate = (dateString) => {
    const date = moment(dateString);

    if (date.isSame(new Date(), 'day')) {
      return `${date.format('hh:mm A')} Today`;
    } else {
      return date.format('hh:mm A MMM DD, YYYY');
    }
  };

  useEffect(() => {
    const startTime = Date.now();

    return () => {
      const endTime = Date.now();
      const totalTimeInSeconds = Math.floor((endTime - startTime) / 1000);
      trackEvent('time_spent_on_file', { file_id: id, time_spent: totalTimeInSeconds });
    };
  }, []);

  return (
    <Box
      sx={{
        marginTop: '85px',
        display: 'grid',
        minHeight: 'calc(100vh - 85px)',
        gridTemplateRows: 'auto 1fr',
      }}
    >
      <Box
        sx={{
          position: 'sticky',
          top: 85,
          zIndex: 1,
          bgcolor: 'background.paper',
        }}
      >
        <TopSection
          handleUndo={handleUndo}
          handleRedo={handleRedo}
          // handleSave={handleSave}
          hasUnsavedChanges={hasChanges}
          editor={editor}
          isEditorReady={isEditorReady}
          setIsSidebarOpen={setIsSidebarOpen}
          usePreviousPath={usePreviousPath}
          todayWorkClick={todayWorkClick}
          setTodayWorkClick={setTodayWorkClick}
          isUndoDisabled={!canUndo}
          isRedoDisabled={!canRedo}
          setFilterApiCall={setFilterApiCall}
        />
      </Box>
      <Box
        sx={{
          display: 'grid',
          height: 'calc(100vh - 170px)',
          gridTemplateColumns: 'auto 1fr',
          gap: 4,
        }}
      >
        <SidePanel
          isOpen={isSidebarOpen}
          setIsOpen={setIsSidebarOpen}
          sx={{
            width: isSidebarOpen ? 385 : 100,
            overflowY: 'auto',
            position: 'sticky',
            top: 165,
            overflowX: 'hidden',
            transition: 'width 0.3s ease',
          }}
        />
        <Box sx={{ flexDirection: 'column', display: 'flex', gap: 1 }}>
          <Stack justifyContent={'end'} alignItems={'end'} mr="30px">
            <Dropdown as={'div'} show={dropdownOpenComment} onToggle={handleToggleDropdownComment}>
              {vendorProofreaderCommentData?.ProofReaderComments?.length > 0 ? (
                <Dropdown.Toggle
                  as={'div'}
                  className="nav-user"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setDropdownOpenComment((prevState) => !prevState);
                  }}
                >
                  <img src={chat_icon} className="img-fluid opacity-50" alt="command-icon" />
                </Dropdown.Toggle>
              ) : null}

              <Dropdown.Menu className="file-toggle-box cursor-default">
                {vendorProofreaderCommentData?.ProofReaderComments?.map((data, index) => (
                  <div className="comment-dropdown-body" key={index}>
                    <div className="d-flex">
                      <Avatar
                        alt="image"
                        src={data?.ProfilePhoto ? `${IMAGE_URL}/${data?.ProfilePhoto}` : null}
                        className="comment-profile-avatar me-3"
                      />
                      <div>
                        <h5 className="d-flex justify-content-between">
                          {data?.ProofReaderName}
                          {vendorResolveProofreaderAPIData && vendorResolveProofreaderAPIData === true ? (
                            <HighlightOffIcon
                              style={{
                                color: 'gray',
                                cursor: 'pointer',
                              }}
                              onClick={handleCloseDropdownComment}
                            />
                          ) : (
                            <>
                              {!data?.isResolved ? (
                                <CheckCircleIcon
                                  style={{
                                    color: hoveredIndex === index ? 'green' : 'currentColor',
                                    cursor: 'pointer',
                                    position: 'absolute',
                                    right: '20px',
                                  }}
                                  onClick={() => {
                                    handleResolved(data?.Id);
                                    handleCloseDropdownComment();
                                  }}
                                  onMouseEnter={() => setHoveredIndex(index)}
                                  onMouseLeave={() => setHoveredIndex(null)}
                                />
                              ) : (
                                <HighlightOffIcon
                                  style={{
                                    color: 'gray',
                                    cursor: 'pointer',
                                    position: 'absolute',
                                    right: '20px',
                                  }}
                                  onClick={handleCloseDropdownComment}
                                />
                              )}
                            </>
                          )}
                        </h5>
                        <div className="comment-dropdown-text">{formatDate(data?.CreatedOn)}</div>
                      </div>
                    </div>
                    <div className="comment-dropdown-text mt-3">{data?.Comment}</div>
                  </div>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </Stack>
          <Paper
            sx={{
              marginX: 2,
              overflowY: 'auto',
              height: 'calc(100dvh - 190px)',
              boxShadow: 'none',
              maxWidth: { sm: '80%', lg: '75%', xl: '60%' },
            }}
            className="custom-scroll"
          >
            {slateDataLoading ? (
              <Loading sx={{ height: 'calc(100vh - 280px)' }} />
            ) : (
              transcriptData && (
                <SlateEditor
                  ref={slateEditorRef}
                  setCanUndo={setCanUndo}
                  setCanRedo={setCanRedo}
                  setEditor={handleEditorInitialized}
                  onContentChange={handleContentChange}
                />
              )
            )}
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default EditorCopy;
